import TtamDevicePrice from './device-price/index.vue';
import TtamDevicePriceRange from './range/index.vue';
import * as hooks from './hooks';

export default {
  TtamDevicePrice,
  TtamDevicePriceRange,
  ...hooks,
};
